import { VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD } from "app/common/LocalConst";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingPatientTransaction } from "app/services/PatientTransaction";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

const DEFAULT_SEARCH = {
  transactionCategory: VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD,
  fromDate: new Date(new Date().getFullYear(), 0, 1),
  toDate: new Date(),
};
export default class HistoryChangeRemainTabStore {
  searchHistoryChangeRemain = {
    ...new SearchObject(),
    ...DEFAULT_SEARCH,
  };
  pageHistoryChangeRemain = new PageResponse();
  openPopupHistoryChangeRemain = null;
  pageHistoryChangeRemainPopup = new PageResponse(); //dùng trong popup
  searchHistoryChangeRemainPopup = {
    //dùng trong popup
    ...new SearchObject(),
    ...DEFAULT_SEARCH,
  };

  constructor() {
    makeAutoObservable(this);
  }

  pagingHistoryChangeRemain = async () => {
    return await pagingPatientTransaction(this.searchHistoryChangeRemain)
      .then(({ data }) => {
        this.pageHistoryChangeRemain = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử chuyển đổi số dư có lỗi");
      });
  };

  handleChangeFormSearch = (searchHistoryChangeRemain) => {
    this.searchHistoryChangeRemain = {
      ...this.searchHistoryChangeRemain,
      ...searchHistoryChangeRemain,
    };
    this.pagingHistoryChangeRemain();
  };

  pagingHistoryChangeRemainPopup = async () => {
    return await pagingPatientTransaction(this.searchHistoryChangeRemainPopup)
      .then(({ data }) => {
        this.pageHistoryChangeRemainPopup = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử chuyển đổi số dư có lỗi");
      });
  };
  handleChangeFormSearchPopup = (searchHistoryChangeRemainPopup) => {
    this.searchHistoryChangeRemainPopup = {
      ...this.searchHistoryChangeRemainPopup,
      ...searchHistoryChangeRemainPopup,
    };
    this.pagingHistoryChangeRemainPopup();
  };
  handleOpenPopupHistoryChangeRemain = async (obj) => {
    try {
      this.handleChangeFormSearchPopup(obj);
      this.openPopupHistoryChangeRemain = true;
    } catch (error) {
      toast.error("Lấy dữ liệu lịch sử chuyển đổi số dư có lỗi");
    }
  };

  handleClosePopupHistoryChangeRemain = () => {
    this.openPopupHistoryChangeRemain = null;
    this.dataHistoryChangeRemain = null;
  };

  resetStore = () => {
    this.searchHistoryChangeRemain = {
      ...new SearchObject(),
      ...DEFAULT_SEARCH,
    };
    this.pageHistoryChangeRemain = new PageResponse();
  };
}
